import { MenuItem, menuItemClasses, MenuList, styled } from "@mui/material";

const Header = styled("div")`
  display: flex;
  padding: 20px;
  flex-direction: row;
  align-items: center;
`;

const DialogBody = styled("div")`
  display: flex;
  flex-direction: column;
  position: relative;
  row-gap: 16px;
  padding: 0px 20px 20px 20px;
`;

const Item = styled(MenuItem)`
  &.${menuItemClasses.root} {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    background-color: #f4f4f4;
    border-radius: 8px;
    padding: 16px;
    row-gap: 8px;
    text-transform: uppercase;
    box-shadow: 0px 1px 1px 0px #00000014;
  }
`;

const ItemContainer = styled(MenuList)`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

export { Header, DialogBody, Item, ItemContainer };
